module.exports = __webpack_public_path__ + "static/c6-528babd3beed66d9a7f59cb7959e7b13.jpg";